import * as React from 'react';
import { DragDropHelperProps } from './DragDropHelperProps';
import { DroppableType } from 'owa-calendar-surface-dategrid';
import { isDragging } from '../../actions/isDragging';
import { trace } from 'owa-trace';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';

/**
 * Base class for all surface drag helper components
 */
export default abstract class SurfaceDragHelperBase<
    TProps extends DragDropHelperProps,
    TState
> extends React.Component<TProps, TState> {
    render() {
        let { surfaceStore } = this.props;
        let { dragDropState } = surfaceStore;

        // Only render the helper if dragging has started and the helper model has
        // been initialized
        if (!isDragging(dragDropState) || dragDropState.helperItemModel == null) {
            this.onNotDragging();
            return null;
        }

        // If surface is in splitMode state, only render if this is the same calendar
        if (
            surfaceStore.dateRangeType !== DateRangeType.Month &&
            surfaceStore.isInSplitView &&
            this.props.splitCalendarFolderId != dragDropState.helperItemModel.ParentFolderId.Id
        ) {
            this.onNotDragging();
            return null;
        }

        if (dragDropState.droppableType != this.droppableType) {
            // Active droppable is not this one, nothing to render
            return null;
        }

        let unfoldedHelpers = this.getUnfoldedHelpers();
        if (!unfoldedHelpers || unfoldedHelpers.length < 0) {
            trace.warn('Skipping drag helper rendering because there are no helpers to render!');
            return null;
        }

        return unfoldedHelpers;
    }

    protected abstract get droppableType(): DroppableType;

    protected abstract onNotDragging: () => void;

    protected abstract getUnfoldedHelpers: () => JSX.Element[];
}
